// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ImageLargeFragmentDoc } from '../../../imageLarge.fragment.generated';
import { LinkFragmentDoc } from '../../../../../graphql/api/cms/link.fragment.generated';
export const CustomProductCarouselCardFragmentDoc = gql`
    fragment customProductCarouselCard on CarouselCustomProduct {
  image {
    ...imageLarge
  }
  description
  link {
    ...link
  }
  title
}
    ${ImageLargeFragmentDoc}
${LinkFragmentDoc}`;